import { Module } from '../Module';
import { _form } from './functions/_form';
import { _onSubmit } from './functions/_onSubmit'

export class Form extends Module {
	initialize() {
		_form();
		_onSubmit();
	}
}
